const CircleIcon = ({ icon }: { icon: string }) => {
  return (
    <div
      style={{
        background: "var(--primary)",
        color: "white",
        borderRadius: "50%",
        width: 20,
        height: 20,
      }}
      className="d-flex align-items-center justify-content-center"
    >
      <i className={icon} style={{ fontSize: 17, lineHeight: 1 }} />
    </div>
  );
};

export default CircleIcon;
